mutation UpdateCollectionType($id: ID!, $input: UpdateCollectionTypeInput!) {
  updateCollectionType(id: $id, input: $input) {
    id
    title
    showInSearch
    collectionDisplayMode
  }
}
